import script from "./SecondarySidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondarySidebar.vue?vue&type=script&setup=true&lang=js"

import "./SecondarySidebar.vue?vue&type=style&index=0&id=2f4cb570&lang=scss&scoped=true"

import exportComponent from "/home/dbomfim/projects/mstr2023/appv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4cb570"]])

export default __exports__